"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildNarrationServiceUrl = void 0;
const typesUtils_1 = require("./typesUtils");
const serviceTypes_1 = require("./serviceTypes");
/**
 * Build the URL to the narration-service
 *
 * @param narrationServiceEndpoint narration service endpoint
 * @param input the request data
 * @param filename (optional) filename
 */
const buildNarrationServiceUrl = (narrationServiceEndpoint, input, filename = "any.mp3") => {
    const { narrator, text, utext, service, rate, volume, metadata } = input || {};
    // Input validation
    if (!narrationServiceEndpoint) {
        throw new Error("No narration service endpoint defined");
    }
    if (!(text || utext)) {
        throw new Error("Missing text. Failed to generate TTS narration URL");
    }
    if (!service) {
        throw new Error("Missing service. Failed to generate TTS narration URL");
    }
    if (!(0, serviceTypes_1.isTextToSpeechService)(service)) {
        throw new Error(`Invalid text to speech service name ${service}. Failed to generate TTS narration URL`);
    }
    // Build URL
    let url = `${narrationServiceEndpoint}tts-service/play?`;
    // narrator & service
    url += `narrator=${encodeURIComponent(narrator)}&service=${encodeURIComponent(service)}`;
    // text or utext
    if (text) {
        url += `&text=${encodeURIComponent(text)}`;
    }
    else {
        url += `&utext=${encodeURIComponent(utext)}`;
    }
    // rate
    if (rate) {
        url += `&rate=${encodeURIComponent(rate)}`;
    }
    // volume
    if (volume) {
        url += `&volume=${encodeURIComponent(volume)}`;
    }
    // metadata
    if (metadata) {
        if (typeof metadata === "string") {
            url += `&metadata=${encodeURIComponent(metadata)}`;
        }
        else {
            url += `&metadata=${encodeURIComponent((0, typesUtils_1.encodeMetadata)(metadata))}`;
        }
    }
    // filename
    url += `&filename=${encodeURIComponent(filename)}`;
    return url;
};
exports.buildNarrationServiceUrl = buildNarrationServiceUrl;
//# sourceMappingURL=urlUtils.js.map